module.exports = __webpack_public_path__ + "img/home.3f87ac18.svg";